import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-ac-rem-ltr',
    templateUrl: './ac-rem-ltr.component.html',
    styleUrls: ['./ac-rem-ltr.component.css'],
    standalone: false
})
export class AcRemLtrComponent implements OnInit {
    businessCoNo;

    acRemLtrKeyno;

    public emailTemplateListButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'emailtemplates' }];

    public emailTemplateEditButtons: FormButton[] = [
        { id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'emailtemplates' },
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'emailtemplate', gotoParms: () => this.page!.emailtemplate_keyno ?? '' }
    ];

    public page?: AcRemLtrGet;

    public selectListEmailTemplates: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
        this.acRemLtrKeyno = this.stateService.getStateParams()['acremltr_keyno'];
    }

    private async loadPage() {
        if (!!this.businessCoNo && !!this.acRemLtrKeyno) {
            this.page = (await this.datatask.Post(3092, {
                businessco_no: this.businessCoNo,
                acremltr_keyno: this.acRemLtrKeyno
            }))[0];
        }
    }

    private async loadEmailTemplates() {
        this.selectListEmailTemplates = await this.datatask.Post(2901, { webpage: 'acreminderproposal' });
    }
    
    public async saveChanges() {
        if (!!this.page) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3093, this.page))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadPage();
        this.loadEmailTemplates();
    }

    ngOnInit() {
        this.init();
    }
}

interface AcRemLtrGet {
    acremltr_keyno: string;
    acremltr_no: string;
    fee_amount_invval: string;
    remintv: string;
    minamount: string;
    businessco_no: string;
    emailtemplate_keyno: string;
}
